export default {"src":"/_next/static/media/show-arrow.6d6e569d.svg","height":12,"width":7};